





















import { Component, Vue } from "vue-property-decorator";
import * as reportService from '@/services/report';
import { cpf } from 'cpf-cnpj-validator';
import { CNPJ } from '@/utils/cnpj';
import { BSpinner } from 'bootstrap-vue';


@Component({
  name: "DocToEconomicGroupReport",
  components: {
    BSpinner,
  },
})
export default class DocToEgReport extends Vue {
  
  private docValue: string = '';

  private cpfInvalid: string[] = [];
  private cnpjInvalid: string[] = [];
  private docInvalid: string[] = [];

  private isDownloadingReport = false;

  private get documents() {
    const onlyNum = this.docValue.replace(/\.|-|\//gm, '');
    const delimiter = /(?:,| |\.|;|\n|\t|\r)+/;
    return onlyNum.split(delimiter).filter(n => !!n).map(d => d.toUpperCase());
  }

  private get wrongMessage() {
    return [this.cpfInvalid, this.cnpjInvalid, this.docInvalid].some(v => v.length > 0);
  }

  private async docValidate() {
    const documents = this.documents;
    if (!documents) { return; }

    this.cpfInvalid = [];
    this.cnpjInvalid = [];
    this.docInvalid = [];

    documents.forEach(doc => {
      if (doc.length === 11 && !cpf.isValid(doc)) {
        this.cpfInvalid.push(doc);
      }
      else if (doc.length === 14 && !CNPJ.isValid(doc)) {
        this.cnpjInvalid.push(doc);
      } 
      else if (doc.length !== 11 && doc.length !== 14) {
        this.docInvalid.push(doc);
      }
    });

    if (!this.wrongMessage && this.documents.length > 0) {
      await this.requestDocumentToEgReport();
    }
    
  }

  private get wrongMessageFormatted() {
    let cpfFormatted = '';
    let cnpjFormatted = '';
    let docFormatted = '';

    const invalidCpfs = `${this.cpfInvalid.join('; ')}`;
    if (this.cpfInvalid.length === 1){
      cpfFormatted = `CPF inválido: ${invalidCpfs}`;
    } else if(this.cpfInvalid.length > 1){
      cpfFormatted = `CPFs inválidos: ${invalidCpfs}`;
    }

    const invalidCnpjs = `${this.cnpjInvalid.join('; ')}`;
    if (this.cnpjInvalid.length === 1){
      cnpjFormatted = `CNPJ inválido:  ${invalidCnpjs}`;
    } else if(this.cnpjInvalid.length > 1){
      cnpjFormatted = `CNPJs inválidos:  ${invalidCnpjs}`
    }

    const invalidDocs = `${this.docInvalid.join('; ')}`;
    if(this.docInvalid.length === 1){
      docFormatted = `A quantidade de digitos deste documento está incorreta: ${invalidDocs}`;
    } else if(this.docInvalid.length > 1){
      docFormatted = `As quantidades de digitos destes documentos estão incorretas: ${invalidDocs}`;
    }

    return [cpfFormatted, cnpjFormatted, docFormatted].join('.<br>');;
  }

  private resetDocValidation() {
    this.docValue = '';
    this.cpfInvalid = []
    this.cnpjInvalid = []
    this.docInvalid = []
  }

  private async requestDocumentToEgReport() {
    const request = this.documents;

    this.isDownloadingReport = true;
    try {
      await reportService.downloadDocToEgReport(request);
    } finally {
      this.isDownloadingReport = false;
    }
  }
}
